export const MOCK_EXTERNALIZED_RESULT: {
	data: {
		cypherQuery: {
			edges: {
				node: {
					columns: {
						key: string;
						value: {
							id: string;
							data: {
								__typename: string;
								id: string;
								accountId: string;
								name: string;
								email: string;
							};
						};
					}[];
				};
			}[];
		};
	};
	extensions: {
		request_id: string;
		trace_id: string;
	};
} = {
	data: {
		cypherQuery: {
			edges: [
				{
					node: {
						columns: [
							{
								key: 'user',
								value: {
									id: 'ari:cloud:identity::user/712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
									data: {
										__typename: 'AtlassianUser',
										id: 'ari:cloud:identity::user/712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
										accountId: '712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
										name: 'Benjamin Schaap',
										email: 'bschaap@atlassian.com',
									},
								},
							},
						],
					},
				},
			],
		},
	},
	extensions: {
		request_id: '892d2aa8-31e3-4208-82a3-52d105f91041',
		trace_id: '892d2aa831e3420882a352d105f91041',
	},
};
